export const TRANSCRIPT_FIELDS = `
    transcript {
        text
        source
        status
        sourceUrl
        urlMetaIndex
        provider
        model
        createdAt
        updatedAt
        segments {
            start
            end
            text
        }
    }
    transcriptionSegments {
        start
        end
        text
    }
`;
